import React from 'react';
import ProjectSlider from './home-comp/ProjectSlider';
import ClientSection from './home-comp/ClientSection';
import Servicesection from './home-comp/Servicesection';
import HeadingSection from './home-comp/HeadingSection';
import Landing from './home-comp/Landing';
import WorkProcess from './home-comp/WorkProcess';
import Counter from './home-comp/Counter'

const Home = () => {
    return (
        <div>
                <Landing />
                <Servicesection />
                <HeadingSection />
                <WorkProcess />
                <ProjectSlider />
                <Counter />
                <ClientSection />
        </div>
    )
}

export default Home

